/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const KlaviyoIcon = ({
  className,
  style: styleFromProps,
  onClick,
  color = 'white',
  size,
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      style={style}
      className={classNames(className)}
      onClick={onClick}
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 17.0356H0V0.964844H24L18.9735 9.00024L24 17.0356Z"
        fill={color}
      />
    </svg>
  );
};
